import { createContext, PropsWithChildren } from 'react';
import type { DashboardWidget } from './dashboardWidgetTypes';

export interface DashboardWidgetContextProps<TContext> {
  Widget: DashboardWidget<TContext>;
  title: string | null;
  onTitleChange: (value: string | null) => void;
  editMode: boolean;
  onDelete: () => void;
}

export const DashboardWidgetContext = createContext<DashboardWidgetContextProps<any>>(null!);

export function DashboardWidgetProvider<TContext>({
  children,
  context,
}: PropsWithChildren<{ context: DashboardWidgetContextProps<TContext> }>) {
  return <DashboardWidgetContext.Provider value={context}>{children}</DashboardWidgetContext.Provider>;
}
